import { Injectable } from '@angular/core';
import { FloorPlan } from '@map/models';
import { BaseService } from '@shared/services/base.service';
import * as _ from 'lodash';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FloorPlanService extends BaseService {
    constructor() {
        super();
        this.setApiName('FloorPlans');
    }

    getImageBlob(imageUrl: string) {
        return this.httpClient.get(imageUrl, { responseType: 'blob' });
    }

    uploadImage(floorPlanId: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.httpClient.post(`${this.apiUrl()}/${floorPlanId}/image`, formData).pipe(
            catchError((error) => {
                return this.handleError(error);
            })
        );
    }

    override patch<T>(id: number, data: any): Observable<T> {
        // Strip server-managed fields before sending to avoid storing expiring imageUrl as permanent reference
        const { imageUrl, secureImageUrl, ...rest } = data;
        return super.patch<T>(id, rest);
    }

    override get<T>(id: number, appendToUrl?: string): Observable<T> {
        return super.get<T>(id, appendToUrl).pipe(
            map((response: any) => {
                return {
                    ...response,
                    secureImageUrl: response.imageUrl, // Assuming imageUrl is the URL to the image
                };
            })
        );
    }

    override mapResponseToObject<T>(response: any): T {
        const floorPlan = new FloorPlan(response) as any;
        return floorPlan;
    }
    override mapArrayResponseToObject<T>(response: any): T {
        return response.map((responseJson: any) => new FloorPlan(responseJson));
    }
}
